import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";

import CustomAlert from "../../../components/CustomAlert";
import { Autocomplete as FormikAutocomplete } from 'formik-material-ui-lab';
import { createPortAuthority } from "../../../../services/portAuthoritiesService";
import { fetchPrfcs } from '../../../../services/prfcsService'
import useLocale from "../../../../hooks/useLocale";
import { useMutation } from "react-query";
import { useQuery } from "react-query";
import { useState } from "react";

const CreatePortAuthorityMunicipalityForm = ({ setFieldValue, errors, touched, values }) => {
  const [error, setError] = useState("");
  const { t } = useLocale();
  const [selectedMunicipalitiesNames, setSelectedMunicipalitiesNames] = useState([]);
  const { data: prfcs } = useQuery('prfcs', fetchPrfcs);

  return (
    <>
      <DialogContent>
        <DialogContentText>
          {t("Fill in the form below and click on Add to add a new Municipalities to Port Authority")}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <DialogContent>
        <Field
          multiple
          name='prf_id_select'
          component={FormikAutocomplete}
          onChange={(event, newValue) => {
            setFieldValue("prf_id", newValue.map((value) => {
              return {
                'id': value.id,
              }
            }))
          }}
          options={prfcs || []}
          getOptionLabel={(options) => options.dscr}
          renderInput={(params) => (
            <TextField
              {...params}
              name='prf_id'
              error={touched['prf_id'] && !!errors['prf_id']}
              helperText={touched['prf_id'] && errors['prf_id']}
              label={t('Municipality / Geographical Department')}
              variant="outlined"
              margin='normal'
            />
          )}
        />
        {selectedMunicipalitiesNames}
      </DialogContent>
    </>
  );
};

export default CreatePortAuthorityMunicipalityForm;
